import React, { useState } from 'react';
import AppHeader from './AppHeader';
import ProjectsSidebar from './ProjectsSidebar';
import { SidebarContext } from './DashboardLayout';
import { NAV_RAIL_WIDTH, NAV_RAIL_EXPANDED_WIDTH } from './layoutConstants';
import AppShell from './AppShell';
import MainContentScrollArea from './MainContentScrollArea';
import { Box } from '@mui/material';
import { Outlet } from 'react-router-dom';

const ProjectsLayout = () => {
  const [navExpanded, setNavExpanded] = useState(false);
  const sidebarWidth = navExpanded ? NAV_RAIL_EXPANDED_WIDTH : NAV_RAIL_WIDTH;

  return (
    <SidebarContext.Provider value={{ sidebarWidth, navExpanded, setNavExpanded }}>
    <AppShell>
      {/* Header fixed at top */}
      <Box sx={{ position: 'fixed', top: 0, left: 0, right: 0, zIndex: 1200 }}>
        <AppHeader />
      </Box>

      {/* Sidebar */}
      <ProjectsSidebar
        expanded={navExpanded}
        onToggleExpanded={() => setNavExpanded((prev) => !prev)}
      />

      <MainContentScrollArea ml={sidebarWidth}>
        <Outlet />
      </MainContentScrollArea>
    </AppShell>
    </SidebarContext.Provider>
  );
};

export default ProjectsLayout;
